import {
  emailValidation,
  nameValidation,
  phoneNumberValidation,
  stringValidation,
} from './base'
import { validator } from './core'

const CHARACTER_ONLY_REGX = /^.*[a-zA-Z].*/
const NUMBER_REGEX = /^\d+$/
const TEST_REGEX = /^(?!.*\b(test|tests|testing)\b).*/

const checkoutCustomerValidation = (countryCode: string) => {
  return {
    firstName: nameValidation('First name'),
    lastName: nameValidation('Last name'),
    email: emailValidation(),
    phone: phoneNumberValidation('Phone Number', countryCode),
    address: validator.string(),
    id: validator.string(),
    company: validator.string(),
    country: validator.string(),
    state: validator.string(),
    city: validator.string(),
    streetName: validator.string(),
    streetNumber: validator.string(),
    subpremise: validator.string(),
    postalCode: validator.string(),
    suburb: validator.string(),
    addressLine1: validator.string(),
    addressLine2: validator.string(),
    isDefault: validator.boolean(),
    latitude: validator.string(),
    longitude: validator.string(),
    label: validator.string(),
    placeId: validator.string(),
    isManual: validator.boolean(),
  }
}

export const checkoutDeliveryCustomerDetailSchema = (countryCode: string) => {
  return validator.object().shape({
    ...checkoutCustomerValidation(countryCode),
    address: validator.string().when('isManual', {
      is: true,
      then: (schema) => {
        return schema.optional()
      },
      otherwise: (schema) => {
        return schema.test(
          'addressfinderAddress',
          'Please select an address from the dropdown',
          (_value, context) => {
            const addressfinderAddress =
              context.parent.addressfinderAddress || ''
            return addressfinderAddress.trim() !== ''
          }
        )
      },
    }),
    addressLine1: validator.string().when('isManual', {
      is: true,
      then: () => {
        return stringValidation('Address Line 1')
      },
    }),
    addressLine2: validator.string().when({
      is: (exists) => {
        return !!exists
      },
      then: (schema) => {
        return schema
          .min(Number('2'), `Please enter a valid address`)
          .matches(TEST_REGEX, 'Please enter a valid address')
      },
    }),
    suburb: validator.string().when('isManual', {
      is: true,
      then: () => {
        return stringValidation('Suburb')
          .min(Number('2'), `Please enter a valid suburb`)
          .matches(CHARACTER_ONLY_REGX, 'Please enter a valid suburb')
      },
    }),
    state: validator.string().when('isManual', {
      is: true,
      then: () => {
        return stringValidation('State')
      },
    }),
    country: validator.string().when('isManual', {
      is: true,
      then: () => {
        return stringValidation('Country')
      },
    }),
    postalCode: stringValidation('Postcode').matches(
      NUMBER_REGEX,
      'Please enter a valid postcode'
    ),
  })
}

export const checkoutClickCollectCustomerDetailSchema = (
  countryCode: string
) => {
  return checkoutDeliveryCustomerDetailSchema(countryCode)
}
